import React, { FC } from 'react'

import {
  Anchor,
  AnchorNav,
  StyledRow,
  TextLink,
  TheContainer,
} from './OnPageNav.styles'
import { BaseBlockProps } from '../../../../types/BaseBlockProps'

type SerialisedLink = {
  text: string
  link: string
}

type Props = BaseBlockProps & {
  links: string
}

export const OnPageNav: FC<Props> = ({ id, links, marginBottom, hiddenAt }) => {
  const parsedLinks = JSON.parse(links) as SerialisedLink[]

  return (
    <AnchorNav id={id} marginBottom={marginBottom} hiddenAt={hiddenAt}>
      {links && parsedLinks && parsedLinks.length > 0 && (
        <TheContainer>
          <StyledRow>
            {parsedLinks.map(({ text, link }, index) => (
              <TextLink key={index} noGutter>
                <Anchor href={`#${link}`}>{text}</Anchor>
              </TextLink>
            ))}
          </StyledRow>
        </TheContainer>
      )}
    </AnchorNav>
  )
}
